<template>
    <b-row>
        <Sidebar v-if="sidebarAccess"/>
        <b-col :md="sidebarAccess === true ? 10 : 12" :offset-md="sidebarAccess === true ? 2 : 0">

            <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h1 class="h2" v-for="user in users">{{user.name}}</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                    <div class="btn-group mr-2">
                        <router-link class="btn btn-outline-secondary" to="/">{{cancelBtn.value}}</router-link>
                    </div>
                </div>
            </div>

            <p v-if="isLoading">Cargando...</p>
            <div v-else>
                <b-form v-on:submit.prevent="onSubmit" v-for="(user, key) in users" v-bind:key="key">
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group id="firstName" label="Nombre:" label-for="firstNameInput" description="">
                                <b-form-input v-model="user.first_name" id="firstNameInput" type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group id="lastName" label="Apellidos:" label-for="lastNameInput" description="">
                                <b-form-input v-model="user.last_name" id="lastNameInput" type="text"
                                              required></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group id="loginName" label="Usuario:" label-for="loginNameInput" description="">
                                <b-form-input v-model="user.username" id="loginNameInput" type="text"
                                              required readonly></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group id="email" label="E-mail:" label-for="emailInput" description="">
                                <b-form-input v-model="user.email" id="emailInput" type="email" required></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-form-row>
                        <b-col md="6">
                            <b-form-group id="password" label="Contraseña:" label-for="passwordInput"
                                          description="Dejar en blanco para mantener contraseña actual.">
                                <b-form-input v-model="user.password" id="passwordInput" type="password"></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col md="6">
                            <b-form-group id="passwordConfirm" label="Confirmar contraseña:"
                                          label-for="passwordConfirmInput"
                                          description="Confirmar contraseña para evitar cambios indeseados.">
                                <b-form-input v-model="user.password_confirm" id="passwordConfirmInput"
                                              type="password"></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-form-row>
                    <b-button type="submit" variant="primary" v-bind:disabled="submitBtn.disabled">{{submitBtn.value}}
                    </b-button>&nbsp;
                </b-form>
            </div>
        </b-col>
    </b-row>
</template>

<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: "Profile",
        data() {
            return {
                isLoading: true,
                cancelBtn: {
                    value: "Cancelar edición"
                },
                submitBtn: {
                    disabled: false,
                    value: "Actualizar"
                }
            }
        },
        computed: {
            ...mapGetters({
                users: 'users/getUsers',
            }),
            sidebarAccess() {
                return this.$store.state.login.isLoggedIn && this.$store.state.login.user.role === 'administrator';
            }

        },
        methods: {
            onSubmit() {
                this.submitBtn.disabled = true;
                this.submitBtn.value = "Actualizando...";

                this.$store.dispatch('users/updateSingleUser').then(() => {
                    this.submitBtn.value = "Usuario actualizado";
                    this.cancelBtn.value = "Regresar";
                });

            }
        },
        created() {
            this.$store.dispatch('users/loadSingleUser', this.$route.params.id).then(() => {
                this.isLoading = false;
            });
        }
    }
</script>